import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByStatusModal = createSelector(
  [(store: RootState) => store.documentsList.showFilterByStatusModal],
  (status) => status
);
